<img [ngClass]='class' [src]='src' alt="Image">